module.exports = {
	INIT_APP: 'INIT_APP',
	STOCK_CONNEXION_URI: 'STOCK_CONNEXION_URI',
	CHECK_REDIRECT_VALUE: 'CHECK_REDIRECT_VALUE',
	HAS_BEEN_REDIRECT: 'HAS_BEEN_REDIRECT',
	GET_PROJECTS: 'GET_PROJECTS',
	GET_CURRENT_PROJECT: 'GET_CURRENT_PROJECT',
	GET_ALL_PROJECTS: 'GET_ALL_PROJECTS',
	FILTER_PROJECTS: 'FILTER_PROJECTS',
	GET_PERSONNAL_PROJECTS: 'GET_PERSONNAL_PROJECTS',
	FILTER_PERSONNAL_PROJECTS: 'FILTER_PERSONNAL_PROJECTS',
	FILTER_PERSONNAL_UNBACKED_PROJECTS: 'FILTER_PERSONNAL_UNBACKED_PROJECTS',
	GET_NOTIFICATIONS: 'GET_NOTIFICATIONS',
	CHECK_FOR_NOTIFICATIONS: 'CHECK_FOR_NOTIFICATIONS',
	GET_BACKED_PROJECTS: 'GET_BACKED_PROJECTS',
	FILTER_INVITATIONS: 'FILTER_INVITATIONS',
	FILTER_BACKED_PROJECTS: 'FILTER_BACKED_PROJECTS',
	GET_PROFILE: 'GET_PROFILE',
	SET_CURRENT_ROUTE: 'SET_CURRENT_ROUTE',
	DISPLAY_MODAL: 'DISPLAY_MODAL',
	HIDE_MODAL: 'HIDE_MODAL',
	POST_PROJECT: 'POST_PROJECT',
	EDIT_PROJECT: 'EDIT_PROJECT',
	GET_USERS_LIST: 'GET_USERS_LIST',
	GET_WALLET: 'GET_WALLET',
	POST_TRANSACTION: 'POST_TRANSACTION',
	ADD_ALLOWED_BACKERS: 'ADD_ALLOWED_BACKERS',
	POST_INVITE_SEEN: 'POST_INVITE_SEEN',
	ANSWER_INVITE: 'ANSWER_INVITE',
	DELETE_PROJECT: 'DELETE_PROJECT',
	INVITE_BACKERS_BY_EMAIL: 'INVITE_BACKERS_BY_EMAIL',
	FILTER_BACKERS_INVITE: 'FILTER_BACKERS_INVITE',
	ACHIEVE_PROJECT: 'ACHIEVE_PROJECT',
	ACHIEVE_PROJECT_EMAIL: 'ACHIEVE_PROJECT_EMAIL',
	MOVE_PROJECT_TO_CURRENT_YEAR: 'MOVE_PROJECT_TO_CURRENT_YEAR',
	GET_ALL_TRANSACTIONS: 'GET_ALL_TRANSACTIONS',
	GET_ALL_WALLETS: 'GET_ALL_WALLETS',
	SEND_BILL_TO_OM: 'SEND_BILL_TO_OM'
};



// WEBPACK FOOTER //
// ./src/Events/index.js